import { Controller } from "@hotwired/stimulus"

// Multi-select for the GDPR template library: keeps a live "n selected" count
// and disables the submit button while nothing new is ticked. Already-added
// templates render checked+disabled, so they never count towards the total.
export default class extends Controller {
  static targets = ["checkbox", "counter", "submit"]

  connect() {
    this.refresh()
  }

  refresh() {
    const count = this.checkboxTargets.filter(cb => cb.checked && !cb.disabled).length
    this.submitTarget.disabled = count === 0
    this.counterTarget.textContent =
      count === 0 ? "" : this.counterTarget.dataset.template?.replace("%{count}", count) || `${count} selected`
  }
}
